import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@sib/ui';
import { LoaderIcon } from '@spendbrain/icons';

interface NewVersionDialogProps {
  open?: boolean;
  onReload: () => void;
}

export const NewVersionDialog = ({ open, onReload }: NewVersionDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogContent className="max-h-[90vh] w-[600px] max-w-[95vw] overflow-auto px-6 py-7 sm:max-w-[70vw] sm:px-[50px]">
        <DialogHeader>
          <div className="flex flex-col items-center gap-7">
            <DialogTitle className="text-primary text-center text-xl leading-7 font-semibold">
              {t('components.newVersionDialog.title')}
            </DialogTitle>
            <DialogDescription className="text-primary text-center text-sm leading-5">
              {t('components.newVersionDialog.subtitle')}
            </DialogDescription>
            <Button onClick={onReload}>
              <LoaderIcon />
              {t('components.newVersionDialog.submit')}
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
